import React, { useEffect, useState } from 'react';
import { AppState } from '../../store/store';
import { fetchAlerts } from '../amlActions';
import { connect, ResolveThunks } from 'react-redux';
import { ApiSortDirection } from '../../api/models';
import { setAlertsPage } from '../amlReducer';
import Alerts from './Alerts';

interface AlertProps {
  personId: string;
}

export const PersonAlerts = ({ personId, fetchAlerts, setAlertsPage, alerts, page, size, total }: Props) => {
  const [fetching, setFetching] = useState(false);

  const updateAlerts = async (filter?: string | undefined, attribute?: string, direction?: ApiSortDirection) => {
    setFetching(true);
    await fetchAlerts(personId, page, size, filter, attribute, direction);
    setFetching(false);
  };

  useEffect(() => {
    fetchAlerts(personId, page, size);
  }, [fetchAlerts, personId, page, size]);

  return (
    <Alerts
      personId={personId}
      page={page}
      size={size}
      total={total}
      loading={fetching}
      alerts={alerts}
      expandable
      expandedByDefault={false}
      attributes={[
        { key: 'ID', sortable: true },
        { key: 'Date', sortable: true },
        { key: 'Details', sortable: true },
        { key: 'Assignee', sortable: true },
        { key: 'Status', sortable: true },
        { key: 'Actions', sortable: true },
      ]}
      onUpdate={updateAlerts}
      onUpdateFilter={updateAlerts}
      onUpdatePage={setAlertsPage}
    />
  );
};

const mapStateToProps = (state: AppState) => {
  const { aml } = state;
  return {
    alerts: aml.alerts.content,
    page: aml.alerts.page,
    size: aml.alerts.size,
    total: aml.alerts.total,
  };
};

const mapDispatchToProps = {
  fetchAlerts: fetchAlerts,
  setAlertsPage: setAlertsPage,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & AlertProps;

export default connect(mapStateToProps, mapDispatchToProps)(PersonAlerts);
